export default __webpack_public_path__ + "static/media/contact.e7b077e6.svg";